import React from 'react';
import './Badge.css';

export function Badge({ children, variant = 'neutral', size = 'md', dot = false, icon: Icon, className = '', title }) {
  return (
    <span className={`ui-badge ui-badge--${variant} ui-badge--${size} ${className}`} title={title}>
      {dot && <span className="ui-badge__dot" />}
      {Icon && <Icon size={size === 'sm' ? 12 : 14} />}
      {children}
    </span>
  );
}
